module.exports = __webpack_public_path__ + "img/IO.39ba8dc8.png";